import { Bell, CalendarDays, Inbox, LayoutGrid, Mail } from "lucide-react";
export const widgetRegistry={
 unread:{title:"未读邮件",description:"所有文件夹的实时未读统计",icon:Mail},
 mailboxes:{title:"邮箱概览",description:"各独立文件夹的实时邮件数量",icon:Inbox},
 calendar:{title:"今日日程",description:"个人日程与会议提醒",icon:CalendarDays},
 announcements:{title:"公告通知",description:"系统管理员发布的企业公告",icon:Bell},
 quickActions:{title:"快捷入口",description:"常用企业邮箱功能",icon:LayoutGrid},
} as const;
export type DashboardWidgetID=keyof typeof widgetRegistry;
